import { render } from "./ChangeMyPassword.vue?vue&type=template&id=4528e9d0"
import script from "./ChangeMyPassword.vue?vue&type=script&lang=ts"
export * from "./ChangeMyPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script